<template>
  <div class="relative w-full">
    <select
      :id="inputId"
      :value="modelValue"
      name="salutation"
      class="border-gray-300 peer w-full border px-4 py-3 !text-base focus:border-gray-secondary focus:ring-1 focus:ring-gray-secondary"
      @input="onInput"
    >
      <option
        v-for="(gender, index) in genders"
        :key="index"
        :value="gender.value"
      >
        {{ gender.label }}
      </option>
    </select>

    <label
      :for="inputId"
      class="pointer-events-none absolute left-2 bg-white px-2 text-base text-black-60 transition-all duration-200 peer-focus:-top-2 peer-focus:text-xs peer-focus:font-bold"
      :class="
        modelValue
          ? '-top-2 text-xs font-bold'
          : 'top-3.5 text-base text-black-60'
      "
    >
      {{ $t('global.salutation.label') }}
    </label>
  </div>
</template>

<script setup lang="ts">
defineProps({
  modelValue: {
    type: String as PropType<Gender> | undefined,
    required: true,
    default: 'f',
  },
  inputId: {
    type: String,
    required: true,
  },
})

const emit = defineEmits<{
  (e: 'update:modelValue', value: string): void
}>()

const { $i18n } = useNuxtApp()

const onInput = (event: Event) => {
  emit('update:modelValue', (event?.target as HTMLInputElement)?.value)
}

const genders: { label: string; value: Gender }[] = [
  {
    label: $i18n.t('global.salutation.w'),
    value: 'f',
  },
  {
    label: $i18n.t('global.salutation.m'),
    value: 'm',
  },
]
</script>
